import * as R from 'ramda'

import ENUM from '../ENUM'
import RankType from '../model/RankType'
import ChartType from '../model/CharType'

export default (question) => {
    const { metadata } = question
    const { kpiType } = metadata
    const hasNumericCodes = Boolean(question?.optionSet?.hasNumericCodes || false)

    const filters = [
        {
            groupId: 'general',
            name: ENUM().chartType,
            options: ChartType.getOptions('RD', kpiType, hasNumericCodes),
        },
        {
            name: ENUM().comparisonSurveyIds,
        },
        {
            name: ENUM().benchmarks,
        },
        {
            groupId: 'general',
            name: ENUM().ranking,
            // first item in array is the default
            options: RankType.getOptions(),
            filter: () => (
                kpiType !== 'NPS'
            ),
        },
        {
            name: ENUM().locked,
            label: 'Lock question',
            options: [
                {
                    label: '',
                    value: 'locked',
                    checked: false,
                    name: ENUM().locked,
                },
            ],
            filter: () => (
                kpiType !== 'NPS'
                && R.pathOr([], ['optionSet', 'options'], question).some(({ isLocked }) => isLocked)
            ),
        },
    ].filter(({ filter }) => (
        typeof filter !== 'function'
        || filter()
    ))

    return {
        kind: 'QuestionSlide',
        filters,
        references: [ENUM().pageQuestionId],
    }
}
